module.exports = __webpack_public_path__ + "img/icn-pagetop-01.46d1b0b8.png";